import { render, staticRenderFns } from "./proposal-result.vue?vue&type=template&id=a6a2a438"
import script from "./proposal-result.vue?vue&type=script&lang=js"
export * from "./proposal-result.vue?vue&type=script&lang=js"
import style0 from "./proposal-result.vue?vue&type=style&index=0&id=a6a2a438&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports